import Vue from "vue";
import Router from "vue-router";
import Cookies from "js-cookie";
import RegistrationStepper from "@/views/login/RegistrationStepper.vue";
import ProfileLayout from "@/layouts/ProfileLayout.vue";
import Profile from "@/views/profile/Profile.vue";
import Children from "@/views/profile/Children.vue";
import Applications from "@/views/profile/Applications.vue";
import ProfileForm from "@/views/profile/ProfileForm.vue";
import Schedule from "@/views/profile/Schedule.vue";
import Acts from "@/views/profile/ActsDetail.vue";
import ApplicationsDetail from "@/views/profile/ApplicationsDetail.vue";
import store from "@/store";

const DefaultLayout = () => import("@/layouts/DefaultLayout.vue");
const Landing = () => import("@/views/Landing.vue");
const Login = () => import("@/views/login/Login.vue");
const AllCourses = () => import("@/views/AllCourses.vue");
const Circles = () => import("@/views/landing/Circles.vue");
const CircleDetails = () => import("@/views/landing/CircleDetails.vue");
const Centers = () => import("@/views/landing/Centers.vue");
const CenterDetails = () => import("@/views/landing/CenterDetails.vue");
const Favorites = () => import("@/views/landing/Favorites.vue");
const Tutoring = () => import("@/views/Tutoring.vue");
const Vacancies = () => import("@/views/Vacancies.vue");
const PopularCourses = () => import("@/views/PopularCourses.vue");
const SportCourses = () => import("@/views/landing/SportCourses.vue");
const CultureCourses = () => import("@/views/landing/CultureCourses.vue");
const UseConditions = () => import("@/views/legalDocuments/UseConditions.vue");
const PrivasyPolicy = () => import("@/views/legalDocuments/PrivasyPolicy.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    // Лэндинг страница
    {
      path: "/",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "Landing",
          component: Landing,
        },
        // Все курсы
        {
          path: "/courses",
          component: AllCourses,
          children: [
            {
              path: "",
              name: "Circles",
              component: Circles,
            },
            {
              path: "centers",
              name: "Centers",
              component: Centers,
            },
            {
              path: "favorites",
              name: "Favorites",
              component: Favorites,
            },
            {
              path: "sport-courses",
              name: "SportCourses",
              component: SportCourses,
            },
            {
              path: "culture-courses",
              name: "CultureCourses",
              component: CultureCourses,
            },
          ],
        },
        {
          path: "/courses/circles/:circleId",
          name: "CircleDetails",
          component: CircleDetails,
        },
        {
          path: "/courses/centers/:centerId",
          name: "CenterDetails",
          component: CenterDetails,
        },
        {
          path: "/tutoring",
          component: Tutoring,
        },
        {
          path: "/vacancies",
          component: Vacancies,
        },
        {
          path: "/popular-courses",
          component: PopularCourses,
        },
        {
          path: "/useConditions",
          component: UseConditions,
        },
        {
          path: "/privacyPolicy",
          component: PrivasyPolicy,
        },
      ],
    },
    {
      path: "/registration",
      name: "Registration",
      component: RegistrationStepper,
    },
    // Страница входа
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    // Профиль
    {
      path: "/profile",
      meta: { requiresAuth: true },
      component: ProfileLayout,
      // meta: { requiresAuth: true }, // Авторизация
      children: [
        {
          path: "",
          name: "Profile",
          component: Profile,
          children: [
            {
              path: "",
              name: "ProfileForm",
              component: ProfileForm,
            },
            {
              path: "children",
              name: "Children",
              component: Children,
              // meta: { requiresAuth: true },
            },
            {
              path: "children/:childId/schedule",
              name: "Schedule",
              component: Schedule,
            },
            {
              path: "children/:childId/schedule/acts/:actId",
              name: "Acts",
              component: Acts,
            },
            {
              path: "applications",
              name: "Applications",
              component: Applications,
              // meta: { requiresAuth: true },
            },
            {
              path: "applications/:applicationId/student/:studentId",
              name: "ApplicationsDetail",
              component: ApplicationsDetail,
              // meta: { requiresAuth: true },
            },
          ],
        },
      ],
    },

    // not found
    {
      path: "*",
      name: "NotFound",
      component: () => import("@/views/NotFoundPage.vue"),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
  const firstEntry = Cookies.get("first_entry") === "true";
  const token = Cookies.get("authToken");

  if (to.path === "/registration" && !firstEntry) {
    return next("/profile");
  }
  if (to.path.startsWith("/profile") && firstEntry) {
    return next("/registration");
  }

  if (requiresAuth && !token) {
    if (to.path !== "/login") {
      return next({ path: "/login", query: { redirect: to.fullPath } });
    }
  }

  if (to.path === "/login" && store.getters["auth/isAuthenticated"]) {
    return next("/profile");
  }

  next();
});

export default router;
